/**
 * ifg-chaos
 */

import { choasAtom } from './atom'
import { createSliderInputComponent } from './_createSliderInputComponent'

const ChaosComp = createSliderInputComponent(
  {
    label: '混沌参数',
    atom: choasAtom,
    helpContent:
      '混沌参数（Chaos）的值越高，相同描述生成的结果风格差异化越大，多样性更强',
    min: 0,
    max: 100,
    step: 1,
    digits: 0,
  },
  'ChaosComp'
)

export { ChaosComp }
